import { Controller } from "@hotwired/stimulus"

// The "+ Add step" menu is a <details>: choosing an item (which opens its dialog) or clicking elsewhere closes it.
// In a branch's track the menu knows which track it is for: choosing an item tells the dialog (two hidden fields) and hides what
// that track cannot read (the written steps and questions of the other tracks), so a step can only be given a result it can see.
export default class extends Controller {
    static values = { scope: String, branchKey: String, track: String }

    connect() {
        this.outside = (event) => { if (!this.element.contains(event.target)) this.close() }
        document.addEventListener("click", this.outside)
    }

    disconnect() {
        document.removeEventListener("click", this.outside)
    }

    choose(event) {
        const dialog = document.querySelector(event.currentTarget.dataset.bsTarget)
        if (dialog) this.prepare(dialog)
        this.close()
    }

    prepare(dialog) {
        dialog.querySelectorAll("input[name=branch_key]").forEach((input) => { input.value = this.branchKeyValue })
        dialog.querySelectorAll("input[name=track]").forEach((input) => { input.value = this.trackValue })
        dialog.querySelectorAll("[data-scope]").forEach((el) => {
            const visible = el.dataset.scope === "" || el.dataset.scope === this.scopeValue
            el.hidden = !visible
            if (el.tagName === "OPTION") el.disabled = !visible
            el.querySelectorAll("input").forEach((input) => { input.disabled = !visible })
        })
        dialog.querySelectorAll("select").forEach((select) => {
            if (select.selectedOptions[0]?.disabled) select.value = [...select.options].find((option) => !option.disabled)?.value ?? ""
        })
    }

    close() {
        this.element.removeAttribute("open")
    }
}
